/* Klasyk w Ramce — konfigurator ramki (podgląd na żywo + zapytanie o wycenę przez formularz kontaktowy Shopify). */
(() => {
  'use strict';
  const root = document.querySelector('[data-k-config]');
  if (!root) return;

  const done = root.querySelector('[data-k-cfg-done]');
  if (done) { done.focus(); done.scrollIntoView({ block: 'center' }); return; }

  const form = root.querySelector('[data-k-cfg-form]');
  if (!form) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.from(root.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let cars = [];
  try { cars = JSON.parse($('[data-k-cars]').textContent || '[]'); } catch (e) { cars = []; }

  const makeSel = $('[data-k-make]');
  const modelSel = $('[data-k-model]');
  const customChk = $('[data-k-custom-car]');
  const customBox = $('[data-k-custom-fields]');
  const cmake = $('[data-k-cmake]');
  const cmodel = $('[data-k-cmodel]');
  const year = $('[data-k-year]');
  const specs = $('[data-k-specs]');
  const story = $('[data-k-story]');
  const refill = $('[data-k-refill]');
  const auto = $('[data-k-auto]');
  const body = $('[data-k-body]');
  const errorEl = $('[data-k-cfg-error]');
  const inCatalog = $('[data-k-in-catalog]');
  const pv = $('[data-k-preview]');
  const pvMake = $('[data-k-pv-make]');
  const pvName = $('[data-k-pv-name]');
  const pvRows = $('[data-k-pv-rows]');
  const pvStory = $('[data-k-pv-story]');
  const bgCustom = $('[data-k-bg-custom]');
  const carCustom = $('[data-k-car-custom]');

  const PLACEHOLDER = {
    pl: ['Rocznik', 'Silnik', 'Moc', 'Skrzynia', '0–100 km/h', 'V-max'],
    en: ['Model Year', 'Engine', 'Power', 'Transmission', '0–100 km/h', 'Top Speed'],
  };

  let current = null;
  let dirty = false;

  const makes = [...new Set(cars.map((c) => c.make))].sort((a, b) => a.localeCompare(b, 'pl'));
  makes.forEach((m) => makeSel.add(new Option(m, m)));

  const lang = () => ((form.querySelector('[data-k-lang]:checked') || {}).value === 'English' ? 'en' : 'pl');
  const checkedHex = (sel) => {
    const el = form.querySelector(`${sel}:checked`);
    if (!el) return null;
    if (el.hasAttribute('data-k-bg-custom-radio')) return bgCustom.value;
    if (el.hasAttribute('data-k-car-custom-radio')) return carCustom.value;
    return el.dataset.hex;
  };
  const specsToText = (arr) => (Array.isArray(arr) ? arr.map((r) => `${r.k}: ${r.v}`).join('\n') : '');
  const textToRows = (t) => t.split('\n').map((l) => l.trim()).filter(Boolean).map((l) => {
    const i = l.indexOf(':');
    return i > 0 ? [l.slice(0, i).trim(), l.slice(i + 1).trim()] : ['', l];
  });
  function luminance(hex) {
    const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex || '');
    if (!m) return 0;
    const [r, g, b] = m.slice(1).map((h) => { const c = parseInt(h, 16) / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  function fillModels() {
    const make = makeSel.value;
    modelSel.innerHTML = '';
    if (!make) {
      modelSel.add(new Option('Najpierw wybierz markę', ''));
      modelSel.disabled = true;
      return;
    }
    modelSel.add(new Option('Wybierz model', ''));
    cars.forEach((c, i) => { if (c.make === make) modelSel.add(new Option(`${c.model}${c.years ? ` (${c.years})` : ''}`, String(i))); });
    modelSel.disabled = false;
  }

  function fillFromCar(force) {
    if (!current) return;
    if (force || !dirty) {
      specs.value = specsToText(current[lang()]);
      story.value = current[`story_${lang()}`] || '';
      dirty = false;
    }
    if (force || !year.value) year.value = current.years || '';
    refill.hidden = !dirty;
  }

  function carName() {
    if (customChk.checked) return `${cmake.value} ${cmodel.value}`.trim();
    return current ? `${current.make} ${current.model}` : '';
  }

  function render() {
    const l = lang();
    pvMake.textContent = (customChk.checked ? cmake.value : current && current.make) || (l === 'en' ? 'Your car' : 'Twoje auto');
    pvName.textContent = (customChk.checked ? cmodel.value : current && current.model) || (l === 'en' ? 'Make & model' : 'Marka i model');
    const rows = textToRows(specs.value).slice(0, 7);
    pvRows.innerHTML = (rows.length ? rows : PLACEHOLDER[l].map((k) => [k, '—']))
      .map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('');
    pvStory.textContent = story.value.length > 240 ? `${story.value.slice(0, 237)}…` : story.value;

    const bg = checkedHex('[data-k-bg]') || '#2a2c30';
    pv.style.setProperty('--plate', bg);
    pv.classList.toggle('is-light', luminance(bg) > 0.45);
    pv.style.setProperty('--frame', checkedHex('[data-k-frame]') || '#0d0d0e');
    const car = checkedHex('[data-k-carcolor]') || '#9aa0a6';
    $$('[data-k-car-body]').forEach((p) => p.setAttribute('fill', car));

    auto.value = carName();
    if (current && current.url && !customChk.checked) {
      inCatalog.innerHTML = `Ten model mamy w katalogu gotowców za <strong>${esc(current.price)}</strong> – <a href="${esc(current.url)}">zamów od ręki</a>.`;
      inCatalog.hidden = false;
    } else {
      inCatalog.hidden = true;
    }
  }

  makeSel.addEventListener('change', () => { current = null; dirty = false; fillModels(); render(); });
  modelSel.addEventListener('change', () => { current = cars[Number(modelSel.value)] || null; year.value = ''; fillFromCar(true); render(); });
  customChk.addEventListener('change', () => {
    customBox.hidden = !customChk.checked;
    makeSel.disabled = customChk.checked;
    modelSel.disabled = customChk.checked || !makeSel.value;
    if (customChk.checked) { current = null; if (!dirty) { specs.value = ''; story.value = ''; } cmake.focus(); }
    else if (modelSel.value) { current = cars[Number(modelSel.value)] || null; fillFromCar(false); }
    render();
  });
  [specs, story].forEach((el) => el.addEventListener('input', () => { dirty = true; refill.hidden = !current; render(); }));
  refill.addEventListener('click', () => { fillFromCar(true); render(); });
  $$('[data-k-lang]').forEach((el) => el.addEventListener('change', () => { fillFromCar(false); render(); }));
  bgCustom.addEventListener('input', () => { const r = $('[data-k-bg-custom-radio]'); r.checked = true; r.value = `Własny (${bgCustom.value})`; render(); });
  if (carCustom) carCustom.addEventListener('input', () => { const r = $('[data-k-car-custom-radio]'); r.checked = true; r.value = `Własny (${carCustom.value})`; render(); });
  form.addEventListener('input', render);
  form.addEventListener('change', render);

  // Preselect z URL: ?marka=BMW&model=M3  lub  ?auto=Fiat 126p
  const params = new URLSearchParams(location.search);
  const pm = params.get('marka');
  const pmodel = (params.get('model') || '').toLowerCase();
  if (pm && makes.includes(pm)) {
    makeSel.value = pm; fillModels();
    const idx = cars.findIndex((c) => c.make === pm && c.model.toLowerCase().includes(pmodel));
    if (idx >= 0) { modelSel.value = String(idx); current = cars[idx]; fillFromCar(true); }
  } else if (params.get('auto')) {
    customChk.checked = true; customBox.hidden = false; makeSel.disabled = true; modelSel.disabled = true;
    cmodel.value = params.get('auto').slice(0, 60);
  }

  form.addEventListener('submit', (e) => {
    errorEl.hidden = true;
    const email = $('[data-k-email]');
    const problems = [];
    if (!carName()) problems.push('wybierz auto albo wpisz markę i model');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) problems.push('podaj poprawny e-mail');
    if (problems.length) {
      e.preventDefault();
      errorEl.textContent = `Uzupełnij: ${problems.join(', ')}.`;
      errorEl.hidden = false;
      (carName() ? email : (customChk.checked ? cmake : makeSel)).focus();
      return;
    }
    const val = (n) => { const el = form.querySelector(`[name="contact[${n}]"]:checked`) || form.querySelector(`[name="contact[${n}]"]`); return el ? el.value : ''; };
    body.value = [
      'ZAPYTANIE O WYCENĘ – KONFIGURATOR',
      `Auto: ${carName()}`,
      `Rocznik/wersja: ${year.value || '—'}`,
      `Kolor modelu 1:64: ${val('Kolor modelu') || 'Obojętnie'} (do potwierdzenia wg dostępności odlewów)`,
      `Tło planszy: ${val('Tło planszy')}`,
      `Ramka: ${val('Ramka')}`,
      `Język planszy: ${val('Język planszy')}`,
      `Dedykacja: ${val('Dedykacja') || '—'}`,
      '',
      'Dane techniczne:',
      specs.value || '(do uzupełnienia przez nas)',
      '',
      'Historia:',
      story.value || '(do uzupełnienia przez nas)',
      '',
      `Uwagi: ${val('Uwagi') || '—'}`,
    ].join('\n');
  });

  render();
})();
